module.exports = __webpack_public_path__ + "img/meeting-bg.1ffe77a2.png";